import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { setItem, getItem } from '../../../utility/LocalStorage'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorProductCategoryMain = () => {
  const { t } = useTranslation()
  const listMainCategory = useCallback(
    (callback, loadingCallback = () => {}) => {
      const category_main = getItem('category-main')
      loadingCallback(true)
      if (category_main != null && category_main.length > 0) {
        callback(category_main)
        loadingCallback(false)
      } else {
        ApiService.jsonRequest(
          '/master-category/main-summary',
          {
            page: 1,
            limit: 1000,
            keywords: {
              text_search: '',
            },
          },
          (response) => {
            loadingCallback(false)
            if (response.status_code === 200) {
              setItem('category-main', response.data)
              callback(response.data)
            } else {
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.message}`),
                timer: 2000,
              })
            }
          },
        )
      }
    },
    [t],
  )

  return { listMainCategory }
}

export default InteractorProductCategoryMain
